import "./profile.css";
import ASSETS from "../../../app/config/assets";
import { useNavigate } from "react-router-dom";
import { capitalizeAll, wait } from "../../../core/utils/helpers";
import Swal from "sweetalert2";
import useLogout from "../../../app/providers/context-provider/useLogout";

const Profile = ({ sys_role, image, username }) => {
  const logout = useLogout();
  const navigate = useNavigate();

  const onHandleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout",
      text: "You are about to stop and quit your current session. Do you really want logout ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, I do",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title:
          '<span style="font-size:1rem; color:grey;">Stopping session and logout process ongoing...</span>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });

      // attendre 1.5 sec
      await wait(1500);

      // logout
      logout();

      // fermer swal si nécessaire
      Swal.close();
    }
  };

  return (
    <div className="profile">
      <img
        src={
          image
            ? `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/${image}`
            : process.env.PUBLIC_URL + "/user.png"
        }
        alt="user visual illustration"
      />
      <div className="profile-options is-hidden">
        <h3>{capitalizeAll(username)}</h3>
        <div
          className="p-o-row"
          onClick={() => navigate(`/${sys_role}/settings`)}
        >
          <img src={ASSETS?.icon_gears_gif} alt="option icon" />
          <span>Settings</span>
        </div>
        <div className="p-o-row" onClick={() => onHandleLogout()}>
          <img src={ASSETS?.icon_logout_gif} alt="option icon" />
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
};

export default Profile;
